import axios from "axios";
import { cryptoUtil } from "./CryptoUtil";
import { getCurrentEnvironment } from "./Environments";
import { clearAllStorage, getSession } from "./StorageUtils";

const handle = {
    request: (data, config) => {
        let payload = { ...data };
        if (getCurrentEnvironment().encoded) {
            payload = cryptoUtil.encode(payload)
            config.headers['content-type'] = "text/plain;charset=UTF-8";
        }
        return payload;
    },
    response: (response, config) => config.handleResponse ? config.handleResponse(response, config) : response,
    config: (url) => {
        let sessionRequired = "/Activities" === url || "/DynamicST/userBalance" === url;
        let session = getSession();
        return ({
            cryptoUtil: getCurrentEnvironment().encoded ? cryptoUtil : undefined,
            redirectCodes: [500, 510, 401, 420],
            headers: {
                Authorization: sessionRequired ? session : getCurrentEnvironment().apiKey
            },
            handleResponse: handleResponse
        });
    }
};

function parseData(config, payload) {
    try {
        if (payload && payload.idUsr && payload.login) {
            getCurrentEnvironment().encoded = false;
            return payload;
        }
        return JSON.parse(config.cryptoUtil.decode(payload));
    } catch (e) {
        return payload
    }
}

export function handleResponse(response, config) {
    let data = response.data;

    if (data.headerStatus.code === 200) {
        if (config.cryptoUtil) {
            return parseData(config, data.data);
        } else {
            return data.data;
        }

    }
    //on error
    let error = "";
    //indicate redirect codes [603,604,303...]
    if (config.redirectCodes && config.redirectCodes.length && config.redirectCodes.includes(data.headerStatus.codes)) {
        clearAllStorage()
        window.location.pathname = "/"
        config.history.replace("/");
        throw new Error("session_expired")
    } else {
        error = data.message || data.headerStatus.description;
        console.error(error)
        throw new Error(error);
    }
}

const axiosApi = axios.create({
    baseURL: getCurrentEnvironment().mainUrl,
    timeout: 30000,
});

axiosApi.interceptors.response.use(
    response => response,
    error => Promise.reject(error)
);

const Api = {
    get: async (url, params) => {
        let config = handle.config();
        config.params = { ...params }
        return await axiosApi.get(url, config).then(response => handle.response(response, config))
    },
    getLang: async (url, params) => {
        let config = handle.config();
        config = { ...config, ...params }
        return await axiosApi.get(url, config).then(response => handle.response(response, config))
    },
    post: async (url, data) => {
        let config = handle.config(url);
        return await axiosApi.post(url, handle.request(data, config), config).then(response => handle.response(response, config))
    }
};

const pfLangConfig = (lang) => ({
    headers: {
        Authorization: "4UXJg6rJT76OOE5OYXV0eHcatm3EXpss"
    },
    baseURL: "https://admin.paguelofacil.com/PFManagementServices/api/v1/",
    params: {
        conditional: `lang::${lang}|group::cryptofacil_app`
    }
});

export const Services = {
    login: (data) => Api.post("/LoginApp", data),
    accountInfo: (data) => Api.post("/accountInfo", data),
    getSystemConfigs: (prop) => Api.get("/SystemConfig", { conditional: `props::${prop}` }),
    searchActivity: (code) => Api.get("/SearchActivity", { conditional: `code::${code}` }),
    payActivity: (data) => Api.post("/Activities", data),
    getUserBalance: (idUsr) => Api.get("/DynamicST/userBalance", { conditional: `selU::${idUsr}` }),
    getLanguage: (lang) => Api.getLang("/LanguageFiles/release", pfLangConfig(lang)),
    getValidateEmailZinli: (params) => Api.post("/CryptofacilCheckZlEmail", params),
    getReceiveData: (codOper) => Api.get("/DynamicST/portalGetReceipt", { conditional: `cOper::${codOper}` }),
}